import { useSelector } from 'react-redux';

import { selectLocale } from '../selectors';

export default function useCurrentLocale() {
  const locale = useSelector(selectLocale);

  return locale;
}
